import React, { FC } from 'react'
import format from 'date-fns/format'
import ja from 'date-fns/locale/ja'
import styles from 'styles/components/calendar.module.scss'
import { Spacer } from 'components/Utility'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getCurrentDate } from 'reducks/calendar/selectors'

const DailyLabel: FC = () => {
  const currentDate = useSelector((state: State) => getCurrentDate(state))

  return (
    <p className={styles.label__daily}>
      <span className={styles.label__daily_year}>{format(currentDate, 'yyyy年')}</span>
      <Spacer size={8} axis={'vertical'} />
      <span className={styles.label__daily_monthDate}>{format(currentDate, 'M月d日')}</span>
      <Spacer size={8} axis={'vertical'} />
      <span className={styles.label__daily_weekday}>{format(currentDate, '(E)', { locale: ja })}</span>
    </p>
  )
}

export default DailyLabel
